import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
    GetScrapFinanceTradesHistoryRequestModel,
    GetScrapFinanceTradesHistoryResponseModel,
} from "@/features/accounts/scrap-finance/services/get-trades-history-model";

export class GetScrapFinanceTradesHistoryApi {
    /**
     * 銀行取込履歴取得API
     */
    public getScrapFinanceTradesHistory = async (
        param: GetScrapFinanceTradesHistoryRequestModel,
    ): Promise<GetScrapFinanceTradesHistoryResponseModel> => {
        const path = `/api/scrapingaccounts/finances/tradeshistory`;
        const res = await ApiClient.instance.get<GetScrapFinanceTradesHistoryResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
